/* eslint-disable import/prefer-default-export */

import { PODCAST_LESSON_SET_EXPANDED_LESSON, PODCAST_LESSON_SET_NEXT_LESSON, PODCAST_LESSON_RESET, PODCAST_LESSON_SET_IS_LOADING, PODCAST_LESSON_SET_PLAY_PODCAST_AUDIO } from '../constants';
export function setOpenedPodcastLesson(openedPodcastLesson) {
  var playPodcastAudio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var shouldScrollIntoView = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: PODCAST_LESSON_SET_EXPANDED_LESSON,
    openedPodcastLesson: openedPodcastLesson,
    playPodcastAudio: playPodcastAudio,
    shouldScrollIntoView: shouldScrollIntoView
  };
}
export function setNextLesson(data) {
  return {
    type: PODCAST_LESSON_SET_NEXT_LESSON,
    data: data
  };
}
export function setIsLoading(isLoading) {
  return {
    type: PODCAST_LESSON_SET_IS_LOADING,
    isLoading: isLoading
  };
}
export function setPlayPodcastAudio(playPodcastAudio) {
  return {
    type: PODCAST_LESSON_SET_PLAY_PODCAST_AUDIO,
    playPodcastAudio: playPodcastAudio
  };
}
export function reset() {
  return {
    type: PODCAST_LESSON_RESET
  };
}